import React from "react";
import classNames from "classnames";

import { useMilestoneEdition } from "@planzone/view-models";
import { useMessage } from "@components/useMessage";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { events } from "@planzone/events";
import { Props } from "./types";
import { EditIcon } from "./editIcon";
import styles from "./styles.scss";

function NameEditionForm({ milestone }: Props) {
  const [name, setName] = React.useState(milestone.name);
  const { editMilestone, isRequestPending } = useMilestoneEdition(milestone);
  const inputRef = React.useRef<HTMLInputElement>(null);

  React.useEffect(() => {
    setName(milestone.name);
  }, [milestone.name]);

  useMessage(
    (message) =>
      message.type === events.editMilestoneFailed &&
      milestone.uuid === message.data.milestone.uuid &&
      setName(milestone.name),
  );

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.nameEditionForm, {
            [styles.edition]: isVisible,
            [styles.pending]: isRequestPending,
          })}
        >
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              editMilestone({
                milestone,
                nextMilestone: { ...milestone, name },
              });
              hide();
            }}
          >
            <input
              ref={inputRef}
              className={styles.input}
              value={name}
              onBlur={() => {
                hide();
                setName(milestone.name);
              }}
              onChange={({ target }) => setName(target.value)}
            />
          </form>
          <div className={styles.name}>
            <h3>{milestone.name}</h3>
            <div
              onClick={(e) => {
                e.stopPropagation();
                show();
                setTimeout(() => {
                  inputRef.current && inputRef.current.focus();
                });
              }}
            >
              <EditIcon className={styles.icon} style={{}} />
            </div>
          </div>
        </div>
      )}
    />
  );
}

export { NameEditionForm };
